import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";
import { useRef } from "react";

export function useDoczClients({ enabled = true }) {
  return useQuery({
    enabled,
    queryKey: ["docz", "clients"],
    queryFn: async () => customFetch(`/api/smartbpm/v1/docz/{tenant}/clientes`),
  });
}

export function useDoczProjects({ enabled = true, params = null}) {
  const paramsRef = useRef({});

  if (params && params !== paramsRef.current) {
    paramsRef.current = params;
  }

  const query = useQuery({
    enabled,
    queryKey: ["docz", "projects", paramsRef.current],
    queryFn: async () => {
      const { idCliente } = paramsRef.current;

      return customFetch(
        `/api/smartbpm/v1/docz/{tenant}/projetos?idCliente=${idCliente}`,
      )
    }
  });

  // possibilita chamar o refetch com parametros
  const refetchWithParams = async (newParams) => {
    paramsRef.current = newParams;
    return query.refetch();
  };

  return { ...query, refetchWithParams };
}

export function useDoczMetadados({ enabled = true, params = null }) {
  const paramsRef = useRef({});

  if (params && params !== paramsRef.current) {
    paramsRef.current = params;
  }

  const query = useQuery({
    enabled,
    queryKey: ["docz", "metadados", paramsRef.current],
    queryFn: async () => {
      const { idProjeto } = paramsRef.current;

      return customFetch(
        `/api/smartbpm/v1/docz/{tenant}/projetos/${idProjeto}/metadados`,
      )
    }
  });

  const refetchWithParams = async (newParams) => {
    paramsRef.current = newParams;
    return query.refetch();
  };

  return { ...query, refetchWithParams };
}

export function useDoczPasta({ enabled = true, params = null }) {
  const paramsRef = useRef({});

  if (params && params !== paramsRef.current) {
    paramsRef.current = params;
  }

  const query = useQuery({
    enabled,
    queryKey: ["docz", "pastas", paramsRef.current],
    queryFn: async () => {
      const { idProjeto } = paramsRef.current;

      return customFetch(
        `/api/smartbpm/v1/docz/{tenant}/projetos/${idProjeto}/pastas`,
      )
    }
  });

  const refetchWithParams = async (newParams) => {
    paramsRef.current = newParams;
    return query.refetch();
  };

  return { ...query, refetchWithParams };
}
